module.exports = "/_next/static/images/82f445152c4731a6d8e2caf72396502a-rec-group.svg.webp";